import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "login_bg" }
const _hoisted_2 = { class: "login-wrap" }

import { ref, onMounted } from "vue";
import LoginPc from "@/components/pc/LoginPc.vue";
import LoginMobile from "@/components/mobile/LoginMobile.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {

const componentStatus = ref(false);

const isMobile = () => {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  if (flag) {
    componentStatus.value = true;
  } else {
    componentStatus.value = false;
  }
};

onMounted(() => {
  isMobile();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(componentStatus.value ? LoginMobile : LoginPc)))
    ])
  ]))
}
}

})